import styles from "./StatsDonut.module.css";

interface StatsDonutProps {
  total: number;
  enviados: number;
  porEnviar: number;
  porReenviar: number;
}

const COLOR_SENT = "#ffffff";
const COLOR_PENDING = "#fdba74";
const COLOR_RESEND = "#a78bfa";
const COLOR_EMPTY = "rgba(255, 255, 255, 0.18)";

export function StatsDonut({
  total,
  enviados,
  porEnviar,
  porReenviar,
}: StatsDonutProps) {
  const safeTotal = Math.max(total, 1);
  const sentDeg = (enviados / safeTotal) * 360;
  const pendingDeg = (porEnviar / safeTotal) * 360;
  const resendDeg = (porReenviar / safeTotal) * 360;
  const used = sentDeg + pendingDeg + resendDeg;
  const remainingDeg = Math.max(0, 360 - used);

  let cursor = 0;
  const segments: string[] = [];
  const push = (color: string, deg: number) => {
    if (deg <= 0) return;
    segments.push(`${color} ${cursor}deg ${cursor + deg}deg`);
    cursor += deg;
  };
  push(COLOR_SENT, sentDeg);
  push(COLOR_PENDING, pendingDeg);
  push(COLOR_RESEND, resendDeg);
  push(COLOR_EMPTY, remainingDeg);

  const gradient = `conic-gradient(${segments.join(", ")})`;

  return (
    <div className={styles.card}>
      <div className={styles.donut} style={{ backgroundImage: gradient }} aria-hidden="true">
        <div className={styles.hole} />
      </div>
      <ul className={styles.legend}>
        <li>
          <span className={styles.value}>{total}</span>
          <span className={styles.label}>Casos na BD</span>
        </li>
        <li>
          <span className={styles.swatch} style={{ background: COLOR_SENT }} />
          <span className={styles.value}>{enviados}</span>
          <span className={styles.label}>Enviados</span>
        </li>
        <li>
          <span className={styles.swatch} style={{ background: COLOR_PENDING }} />
          <span className={styles.value}>{porEnviar}</span>
          <span className={styles.label}>Por enviar</span>
        </li>
        <li>
          <span className={styles.swatch} style={{ background: COLOR_RESEND }} />
          <span className={styles.value}>{porReenviar}</span>
          <span className={styles.label}>Por reenviar</span>
        </li>
      </ul>
    </div>
  );
}
